export function debounce (fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}

export const formatPrice = (value, decimals = 3) => {
  if (isNaN(value)) return '';

  return Number(value)
    .toFixed(decimals)
    .replace('.', ',') // Reemplaza el punto decimal por una coma
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Agrega puntos como separadores de miles
}

export const inputPrice = (value) => {
  // Permitir números, puntos y comas
  let formattedValue = value.target._value.replace(/[^0-9.,-]/g, ""); 
  return formattedValue;
}

export const parseEuroNumber = (value) => {
  return parseFloat(value.replace(/\./g, '').replace(',', '.'));
}